module.exports = __webpack_public_path__ + "static/media/give-ticket.27a258d3.svg";